import { DataGetUseCase } from '../../../application';

export default class DataGetService {
    constructor() {}

    async execute(event) {
        const request = await DataGetUseCase(event);

        return request;
    }
}
